import React from 'react';
import { Box } from 'localmed-core';

interface IProps {
  content;
}

export default function ({ content }: IProps) {
  return (
    <Box color="errorText" backgroundColor="errorBackground" p="md" borderRadius="md">
      {content}
    </Box>
  );
}
